module.exports = __webpack_public_path__ + "img/6.19b1ff8f.jpg";